!function(name, module, context) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (window.define)
	define('widgets/ct_offermgmt',[ 'vendor/mustache', 'widgets/jquery.slider'], module)
	else
	    //>>excludeEnd("requireTmpl");
	    context[name] = module(Mustache)
}('Offers', function(Mustache) {

    var sliderOptions = {
	    width : 620,
	    enableCSS3 : false,
	    generatePagination: true,
	    play: {
		effect: "slide",
		interval: 8000,
		auto: false,
		pauseOnHover: true
	    }

    };

    var offers = {
	    init : function(opts) {
		if(offers._init) return;
		var s = $.extend({
		    product : 'air',
		    page : 'home',
		    url : '',
		    onsuccess : offers.onsuccess
		}, opts || {});
		
		if(window.CT.langUrlPrefix == "/ar"){
			s.url = window.CT.langUrlPrefix + s.url;
		}
		if(s.sliderOptions) sliderOptions = s.sliderOptions
		var _offer = this;
		CT.getScript(s.url, function() {
		    try {
			_offer.render(s.product, s.page, s.onsuccess);
			CT.utils.helperFunctions.adjustHeight();
		    } catch(e) {}
		})
	    },


	    onsuccess : function($el , data){
		// dirty fix for one slide carousel, because the "widgets/jquery-slider.js" is buggy, and this is rare scenario
		//TODO: to be relooked 
		var loadedCb,completedCb;
		if(data && data.length == 1){ 
		    sliderOptions.callback = sliderOptions.callback ||{};
		    loadedCb = sliderOptions.callback.loaded || function(){};

		    sliderOptions.callback.loaded = function(slideId){
			$el.find(".next.sliderNavigation, .previous.sliderNavigation, .sliderPagination-item").hide()
			.end().find(".next.sliderNavigation").click()
			.end().find(".slidesjs-slide").hide();

			loadedCb(slideId);

			setTimeout(function(){
			    $el.find(".slidesjs-slide").show();
			},1000)
		    }
		}
		
		// if autoplay enabled.
		if(window.home_offers && window.home_offers.autoplay === 'Y') {
			if(window.home_offers.autoplaypausetime && window.home_offers.autoplaypausetime[0] !="N" && window.home_offers.autoplaypausetime.length > 0){
			    var pauseStartTime=window.home_offers.autoplaypausetime[0].split('-')[0];
			    var pauseEndTime=window.home_offers.autoplaypausetime[0].split('-')[1];
			    var currentTime = window.serverCurrentDate ? window.serverCurrentDate.getTime() : (new Date()).getTime();
			    pauseStartTime = moment(pauseStartTime, "DD/MM/YYYY HH:mm").valueOf();
			    pauseEndTime = moment(pauseEndTime, "DD/MM/YYYY HH:mm").valueOf();
		        if((currentTime - pauseStartTime) > 0 && (pauseEndTime - currentTime) > 0){
		        	sliderOptions.play.auto = false;
		        }
		        else{
		        	sliderOptions.play.auto = true;
		        }
			}else{
				sliderOptions.play.auto = true;
			}
		}
		sliderOptions.callback = sliderOptions.callback || {};
		sliderOptions.callback.next = function(next,prev){
			CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_switchDeal",{
				"source":"next",
				"newPos":next,
				"oldPos":prev
			});

		}
		
		sliderOptions.callback.previous = function(next,prev){
			CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_switchDeal",{
				"source":"previous",
				"newPos": next,
				"oldPos":prev
			});
		}
		sliderOptions.callback.numberclick = function(next,prev){
			CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Home_switchDeal",{
				"source":"number",
				"newPos":next,
				"oldPos":prev
			});
		}

		$el.slidesjs(sliderOptions);
		offers._init = true;
	    },
	    
	    render : function(product, page, callback) {
		page = _.capitalize(page)
		var str = product + page;
		var $elem = $("#"+str+"OfferBlock");
		var offerJson = eval(window.home_offers.offers || window.home_offers);
		if(window.CT.langUrlPrefix.substr(1) == 'ar') // Arabic language 
		{
			_.each(offerJson,function(offer)
					{
			    		offer.DESC1 = offer.DESC1_AR || offer.DESC1;
			    		offer.HEADING = offer.HEADING_AR || offer.HEADING;
			    		offer.TITLE = offer.TITLE_AR || offer.TITLE;
				    }
				);
		}

		html = CT.to_html(str+'OfferTpl', {
		    offerjson: offerJson
		});
		//console.log("Offers rendered")

		var $replaceLink = $elem.prev()
		var tmp_html = $replaceLink.html()
		$replaceLink.replaceWith('<div class="dealHeader"></div>').end().append(html).prev().html(tmp_html);
		callback && callback($elem , offerJson);
		if(str === "hotelHome"){
		    //CT.utils.helperFunctions.trackGAEvent('Hotels_TS','H_Offers_View','Offer0');
		    $elem.find(".offerTitle,.offerLink").click(function(evt){
		    	var offerTitle = $(this).parent().find('.offerTitle').text();
		    	var offerDes = $(this).siblings('.offerDescription').text();
		    	var cariousalRank = Number($(this).parent().attr("slidesjs-index")) + 1;
		    	var offerLink = $(this).attr("href");
		    	CT.utils.helperFunctions.trackGAEvent('Hotels_TS','H_Offers_Click', cariousalRank + ':'+ offerTitle +':'+ offerLink,'0');
				//console.log("show more offer clicked"+$(this).parent().attr("slidesjs-index"))
				CT.utils.helperFunctions.trackMixpanelEvent('H_Hotel_Deals',{'dealName': offerTitle,'dealURL': offerLink,'dealRank': cariousalRank });
				//cleverTap evnets for hotels
				//Regex to read capital letter from offer description 
				var coupanCode = offerDes.match(/\b([A-Z]{1,})\b/g) || offerDes.match(/\b([0-9]{1,})\b%/g) || [];
				coupanCode = coupanCode.join("+");
				
				var offerDetails = (offerTitle + " + " + coupanCode).trim();
				//Regex to remove new line and tabs space from string
				//.trim().replace(/\n|\s+/g," ");

				CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Home_Offers_Clicked', {
					"offerDetails": offerDetails,
					"cariousalRank": cariousalRank,
					"originCity": CT.utils.cookies.read('userHomeCity') ?  CT.utils.cookies.read('userHomeCity') : "N/A"
				});
		    });
		}
		else{
		    //CT.utils.helperFunctions.trackGAEvent('HOME_TS','view','Offer0');
		    $elem.find(".offerTitle").click(function(){
			    var offerLabel=(Number($(this).parent().attr("slidesjs-index")) + 1)+":"+$(this).text().trim()+":"+$(this).attr("href");
	            CT.utils.helperFunctions.trackGAEvent('Flights_TS','Deals_Clicked',offerLabel,'100');
		    })
		    $elem.find(".offerLink").click(function(evt){
		    var offerLabel=(Number($(this).parent().attr("slidesjs-index")) + 1)+":"+$(this).text().trim()+":"+$(evt.target).attr("href");
            CT.utils.helperFunctions.trackGAEvent('Flights_TS','Deals_Clicked',offerLabel,'100');
		    })
		}

		if (window.productCode != "CP" && window.productCode != "AG" && (["in","ae","sa","kw"].indexOf(window.countryCode)>-1)) {
		    $elem.find(".sliderPagination").addClass("number")
		    /*var viewOfferhtml='india';
		    if (window.countryCode == "ae") {
			viewOfferhtml='uae';
		    }*/
		    var viewOfferhtml={
		    	in: 'india',
		    	ae: 'uae',
				sa: 'saudi-arabia',
				kw: 'kuwait'
		    }
		    htmlToAdd ="<li class='fRight'><a href='https://"+location.hostname+"/offers/"+((window.countryCode=='sa' && CT.utils.cookies.read('lp')=='ar')?'ar/':'')+viewOfferhtml[window.countryCode]+"' class='viewAll' target='_blank'>View all <i class='searchSprite icoViewAll'></i></a></li>";
		    $elem.find(".sliderPagination").append(htmlToAdd);
		};

		try{
		    // go through flash sale code.
		    var flashSaleOffers = window.home_offers.flashsale;
		    var isArabicFlow = window.CT.langUrlPrefix && window.CT.langUrlPrefix.substr(1) == 'ar'
		    if(!flashSaleOffers || flashSaleOffers.length == 0) {
				// it will show the other trust markers.
				CT.utils.helperFunctions.showFlashSaleTag_v2({});
		    } else {
				for(var i = 0; i < flashSaleOffers.length; i++) {
					if(isArabicFlow && flashSaleOffers[i].OFFERTEXT){
						flashSaleOffers[i].OFFERTEXT = (flashSaleOffers[i].OFFERTEXT_AR || flashSaleOffers[i].OFFERTEXT)
					} // Arabic language 
					CT.utils.helperFunctions.showFlashSaleTag_v2(flashSaleOffers[i]);
				}
		    }
		}
		catch(e){}
	    }
    }

    return offers;
}, CT)



;
